import { type TooltipPlacement } from "antd/lib/tooltip";

export interface IHotkey {
  friendlyName: string;
  command: string;
  supportedTags?: AvailableTags[];
}

export type AvailableTags = "INPUT" | "TEXTAREA" | "SELECT";
// global key commands
export type THotkeyCommands =
  | "save"
  | "print"
  | "saveAndClose"
  | "new"
  | "delete"
  | "complete"
  | "checkAll"
  | "helpCenter"
  | "search"
  | "close"
  | "showHotkeys"
  | "navRight"
  | "navLeft"
  | "navUp"
  | "navDown"
  | "sendChat"
  | "enter"
  | "undo"
  | "redo";

export interface IHotkeyWithPopoverConfig {
  hotkey: THotkeyCommands;
  popoverPlacement: TooltipPlacement;
}

/**
 * A hotkey as accepted on a component prop: either a bare command string
 * ("ctrl+s, cmd+s") or a command paired with the label the ctrl+/ overlay shows.
 */
export type THotkey = string | { friendlyName: string; command: string };

/**
 * Normalizes a {@link THotkey} into the shape {@link useHotkey} takes.
 * @param hotkey the prop value, which may be undefined when no hotkey is set.
 * @param fallbackName label to use when the caller passed only a command string.
 */
export function resolveHotkey(
  hotkey: THotkey | undefined,
  fallbackName: string,
): { command: string; friendlyName: string } | undefined {
  if (!hotkey) {
    return undefined;
  }
  return typeof hotkey === "string"
    ? { command: hotkey, friendlyName: fallbackName }
    : { command: hotkey.command, friendlyName: hotkey.friendlyName };
}
